export const isFinalOrderStatus = (statusName: string | null | undefined): boolean => {
  if (!statusName) return false;
  const finalStatuses = [
    'Delivered',
    'Refuse',
    'CollectedMoney',
    'BranchReplacement',
    'RequestChangeCourierService',
    'DeleteRequest',
    'ReturnedStock',
  ];
  return finalStatuses.includes(statusName);
};
